import React from "react";
import { ClipPath, Defs, G, Path, Rect, Svg } from "react-native-svg";

export function CaretUpFill({
  width = 20,
  height = 20,
  color = "#33393D",
  strokeColor = "#5A6066",
  ...props
}) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <Defs>
        <ClipPath id="clip0_up">
          <Rect width="20" height="20" fill="white" />
        </ClipPath>
      </Defs>
      <G clipPath="url(#clip0_up)">
        <Path
          d="M3.75012 13.0859L3.74994 13.0859C3.63428 13.0863 3.52108 13.0524 3.42463 12.9885C3.32832 12.9248 3.25301 12.834 3.20816 12.7275C3.16597 12.6191 3.15529 12.5009 3.17736 12.3867C3.19943 12.2724 3.25332 12.1668 3.33283 12.0819L9.58192 5.83284C9.582 5.83275 9.58207 5.83266 9.58215 5.83258C9.6943 5.7243 9.84414 5.66382 10.0001 5.66382C10.1561 5.66382 10.3059 5.7243 10.4181 5.83258C10.4182 5.83266 10.4183 5.83275 10.4183 5.83284L16.6674 12.0819C16.7469 12.1668 16.8008 12.2724 16.8229 12.3867C16.845 12.5009 16.8343 12.6191 16.7921 12.7275C16.7472 12.834 16.6719 12.9248 16.5756 12.9885C16.4791 13.0524 16.3659 13.0863 16.2502 13.0859H16.2501L3.75012 13.0859Z"
          fill={color}
          stroke={strokeColor}
          strokeWidth="0.078125"
        />
      </G>
    </Svg>
  );
}
